function _ResponsiveTitles() {
    this.extends = [_ResponsiveLayout, _ContentLayout, _Helpers];
    this.node = null;
    this.id = null;
    this.declaredClass = null;
    this._imageRatio = 0.46206897;  // this value also in Search.js, FeaturedImage.js, RelatedPosts.js
    this.layout_type = null;

    this.init = function() {};

    this.initAllReady = function() {};

    this.resize = function(type) {
        this.layout_type = type;
        if (type == 'desktop' || type == 'mobile') {
            var title_width = $('.thumb', this.node).outerWidth();
            var title_height = (title_width * this._imageRatio) - $('.date', this.node).outerHeight();
            var texts = $('.text', this.node);
            for (var i = 0; i < texts.length; i++) {
                $(texts[i]).css('height', title_height);
                this.truncateText(texts[i]);
            } 
        }
        if (type == 'tablet') {
            var texts = $('.text', this.node);
            for (var i = 0; i < texts.length; i++) {
                var title = $('.contentContainer', texts[i]).attr('title');
                if (typeof title != 'undefined')
                    $('.contentContainer', texts[i]).text(title);
                $(texts[i]).css('height','auto');
            }  
        }
    };

    this.reLayout = function(){
        if (this.layout_type !== null)
            this.resize(this.layout_type);
    };
}